<template>
  <div id="app">
    <vue-scroll-progress-bar
      height="0.6rem"
      containerColor="#C5C5C5"
      backgroundColor="#2C2C2C"
     />

    <hud></hud>

    <div class="scroll-helper not-mobile">
      <span class="links">Scrollez vers le bas</span>
    </div>
    <works></works>
    <div class="scroll-helper not-mobile">
      <span class="links">Scrollez vers le haut</span>
    </div>
  </div>
</template>

<script>
import Hud from '@/components/Hud.vue'
import Works from '@/components/Works.vue'

export default {
  name: 'app',
  components: {
    Hud,
    Works
  }
}
</script>

<style src="@/styles/styles.scss" lang="scss"></style>
